import { z } from 'zod';

export const updateMinMaxCapacitySchema = z.object({
	min: z.string().min(1, { message: 'Minimum capacity is required' }),
	max: z.string().min(1, { message: 'Maximum capacity is required' })
});

export type UpdateMinMaxCapacityFormSchema = z.infer<typeof updateMinMaxCapacitySchema>;
